<template>
  <div class="input-group date w-100">
    <div class="timepicker input-controls-container w-100" role="presentation">

    <input
        type="text"
        :id="id"
        :placeholder="placeholder"
        class="form-control datepicker-input"
        v-mask="'####-##-##'"
        v-model="dateDisplayed"
        achange="setDate"
        @change="checkDate"
        @mousewheel.prevent="scroll"
        @keydown="keyDown"
        
        :aria-label="aria+' '+title"
        :title="title"
        :name="name"
      >
      
    <div class="input-controls jsInputTimepickerControls" role="presentation" v-if="!hideControls">

        <span title="Następny dzień" class="prev bi bi-caret-up-fill" @click="addDay()"></span>
        <span title="Poprzedni dzień" class="next bi bi-caret-down-fill" @click="subtractDay()"></span>
    </div>

    <div :id="id + '_aria'" class="sr-only">
      {{aria}} {{title}}
    </div>


  </div>

    <button type="button" aria-expanded="false" :id="id + '_trigger'" class="datepicker-trigger input-group-addon" @click="showCalendar" aria-label="Kalendarz">
      <span class="icon"></span>
    </button>  
      

    <AirbnbStyleDatepicker
        :trigger-element-id="id + '_trigger'"
        :mode="'single'"
        :fullscreen-mobile="false"
        :date-one="dateOne"
        @date-one-selected="setDateOne"
        :minDate="minDate"
        :end-date="endDate"
        :monthsToShow="1"
        :trigger="opened"
        @closed="closeCalendar"
      />

  </div>
</template>

<script>
import Vue from 'vue'
// import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import format from 'date-fns/format'
import moment from 'moment'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

const datepickerOptions = {
  days: [
    'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'
  ],
  daysShort: [
    'Pn', 'Wt', 'Śr', 'Czw', 'Pt', 'So', 'Nd'
  ],
  monthNames: [
    'Styczeń',
    'Luty',
    'Marzec',
    'Kwiecień',
    'Maj',
    'Czerwiec',
    'Lipiec',
    'Sierpień',
    'Wrzesień',
    'Październik',
    'Listopad',
    'Grudzień'
  ],
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  // ariaLabels: {
  //   chooseDate: (date) => date,
  //   chooseStartDate: (date) => `Data początkowa. ${date}`,
  //   chooseEndDate: (date) => `Data końcowa. ${date}`,
  //   selectedDate: (date) => `Wybrana data. ${date}`,
  //   unavailableDate: function(date) { return 'Not available. ' + date;},
  //   previousMonth: 'Move backward to switch to the previous month.',
  //   nextMonth: 'Move forward to switch to the next month.',
  //   closeDatepicker: 'Zamknij kalendarz.',
  //   openKeyboardShortcutsMenu: 'Otwarcie pomocy.',
  //   closeKeyboardShortcutsMenu: 'Zamknięcie pomocy.'
  // },
  keyboardShortcuts: [
    {symbol: '↵', label: 'Wybrór daty', symbolDescription: 'Enter'},
    {symbol: '←/→', label: 'Następny/poprzedni dzień.', symbolDescription: 'Strzałka w lewo/prawo'},
    {symbol: '↑/↓', label: 'Następny/poprzedni tydzień.', symbolDescription: 'Strzałka góra/dół'},
    {symbol: 'PgUp/PgDn', label: 'Następny/poprzedni miesiąc.', symbolDescription: 'PageUp/PageDown'},
    {symbol: 'Home/End', label: 'Pierwsz/ostatni dzień tygodnia.', symbolDescription: 'Home/End'},
    {symbol: 'Esc', label: 'Zamknięcie pomocy', symbolDescription: 'ESC'},
    {symbol: '?', label: 'Pomoc', symbolDescription: '?'}
  ],
}



Vue.use(AirbnbStyleDatepicker, datepickerOptions)

export default {
  name: 'IcDatePicker',
  props: {
    hideControls: {
        type: Boolean,
        value: false
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    title: {
      type: String,
      default: "Data nie może być późniejsza niż 1 miesiąc od dziś. Użyj strzałek by zmienić datę o jeden dzień."
    },
    dateFormat:  {
      type: String,
      default: 'YYYY-MM-DD'
    },
    internalDateFormat: {
      type: String,
      default:'YYYY-MM-DD'
    },
    id: {
      type: String,
      required: true
    },
    v: {
      type: Object
    },
    minDate: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    },
    endDate: {
      type: String,
      default: moment().add(1, 'years').format('YYYY-MM-DD')+''
    },
    placeholder: {
      type: String,
      default: 'RRRR-MM-DD'
    },
    aria:{
      type: String,
      default: 'Data - podaj datę w formacie cztery cyfry roku - dwie cyfry miesiąca - dwie cyfry dnia'
    }
  },
  data() {
    return {
      dateOne: this.value,
      opened: false,
      dateDisplayed: '',
    }
  },
  watch: {
    'dateDisplayed' : function(newValue, oldValue)  {
      if (newValue !== oldValue) {
         let b = moment(this.dateDisplayed,"YYYY-MM-DD");
         if(b.isValid() && b.format("YYYY-MM-DD") == this.dateDisplayed)
            this.$emit('input', this.dateDisplayed)
      }
    },
    // 'value' : function(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //      let b = moment(newValue,"YYYY-MM-DD");
    //       console.log(b.isValid())
    //   }
    // }
  },
  methods: {
    formatDate(dateOne) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      return formattedDates
    },
    setDateOne(val) { 
      let b = moment(val,"YYYY-MM-DD");
       if(!b.isValid()) {
         return;
       }
      this.dateOne = val
      
      this.dateDisplayed = this.formatDate(this.dateOne)
      if (this.v) {
        this.v.$touch()
      }
    },
    scroll(event) {
      event.deltaY < 0 ? this.addDay() : this.subtractDay()
    },

    checkDate(e) {
     let val = e.target.value;

      if(this.endDate){
        let a = moment(this.endDate,"YYYY-MM-DD");
        let b = moment(val,"YYYY-MM-DD");
        if(b.isValid() && b.isBefore(a)) val = b.format("YYYY-MM-DD");
        else
        if(b.isValid() && b.isAfter(a))
          val = a.format("YYYY-MM-DD");
        else
        val = moment().format("YYYY-MM-DD");
      }

      if(this.minDate){
        let a = moment(this.minDate,"YYYY-MM-DD");
        let b = moment(val,"YYYY-MM-DD");
        if(!b.isValid() || b.isBefore(a)) val = a.format("YYYY-MM-DD");
        else
        val = b.format("YYYY-MM-DD");
      }

      this.setDateOne(val);
      
    },
    
    
    setDate(e) {
      this.dateOne = e.target.value
      this.checkDate(e);
    },
    showCalendar() {
      setTimeout(() => this.opened = true, 200)
      
    },
    closeCalendar() {
        this.opened = false
    },
    addDay() {
      if (!this.dateOne) {
        let one = moment(new Date);
        this.dateOne = one.format('YYYY-MM-DD');
        if(this.minDate){
          let a = moment(this.minDate,"YYYY-MM-DD");
          if(one.isBefore(a)) this.dateOne = a.format('YYYY-MM-DD');
        }

      }
      this.dateOne = moment(this.dateOne).add(1, 'd').format('YYYY-MM-DD');
      if(this.maxDate){
          let a = moment(this.maxDate,"YYYY-MM-DD");
          if(moment(this.dateOne,"YYYY-MM-DD").isAfter(a)) this.dateOne = a.format('YYYY-MM-DD');
        }         
    },
    subtractDay() {
        if (!this.dateOne) {
        let one = moment(new Date);
        this.dateOne = one.format('YYYY-MM-DD');
        if(this.minDate){
          let a = moment(this.minDate,"YYYY-MM-DD");
          if(one.isBefore(a)) this.dateOne = a.format('YYYY-MM-DD');
        }        
      }
      
      if(this.minDate){
          let a = moment(this.minDate,"YYYY-MM-DD");
          if(moment(this.dateOne,"YYYY-MM-DD").subtract(1, 'd').isBefore(a)) this.dateOne = a.format('YYYY-MM-DD');
      } 
      else 
        this.dateOne = moment(this.dateOne).subtract(1, 'd').format('YYYY-MM-DD');
    },
    keyDown(event) {
      switch(event.key) {
        case 'ArrowDown' : 
        case 'Down' :
          this.subtractDay();
          break;
        case 'ArrowUp':
        case 'Up' :
          this.addDay();
          break;
        case 'Down' :
        case 'Enter' :
          if (!this.opened) {
            event.preventDefault();
            this.opened=true;
          }
          break;
      }
    }
  },
  components: {
    // AirbnbStyleDatepicker
  }
}
</script>
<style src="vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.css"></style>
<style lang="scss">
  
.datepicker-trigger {
    line-height: 3rem;
    margin-left: 1rem !important;
    font-size: 1.25rem; 
    position: absolute !important;
    .icon {
      background: transparent url("/images/icons/icon-calendar.svg") no-repeat center;
      display: block;
      width: 24px;
      height: 24px;
      margin: 12px 0 0 -6px;
    }
 }
 .datepicker-input.form-control{
  padding-left: 2.5rem !important;
 }

.input-controls {
    height: 100%;
    position: absolute;
    top: 0;
    right: 10px;
    z-index: 10;
    font-size: 6px;
    .prev,
    .next {
        position: absolute;
        right: 0;
        display: block;
        text-align: right;
        cursor: pointer;
        padding-right: 0;
        font-size: 15px;
        line-height: 15px;
    }
    .prev {
        top: 10px;
        padding-top: 0px;
    }
    .next {
        bottom: 10px;
    }
}  
                                            
  $col-ic-blue: #0076c8;
  $col-ic-blue-hover: #128ee4;
  $col-ic-orange: #f58220;
  $col-ic-highcontrast-text: #fff200;
  $col-ic-highcontrast-input-bg: #3a3a3a;

  .asd__wrapper {
    background: $col-ic-blue;
    color: white;
    top:100% !important;
    left: 0 !important;
    right: 0 !important;    
  }
  .asd__month-name {
    font-weight: normal;
  }

  .asd__month-table {
    background: transparent;
    border-collapse: separate;

  }
  .asd__day--disabled {
    background: transparent !important;
    color: lighten($col-ic-blue,10%) !important;
  }
  .asd__day--enabled {
    border-color: transparent;
    color: white !important;
    &:focus {
      outline-color: $col-ic-orange
    }
    &:hover {
      background-color: lighten($col-ic-blue, 20%);
      border-color: lighten($col-ic-blue, 20%);
    }
  }
  .asd__day--selected {
    background-color: $col-ic-orange!important;
    border-color: $col-ic-orange!important;
  }
  .asd__day--today {
    border-color: lighten($col-ic-blue,20%)!important;
  }

  .asd__day-title {
    color: white;
    
  }

  .asd__change-month-button {
    background: transparent;
    
    
    > button {
      border-color: transparent;
      background: transparent;
      border-radius: 0;
      &:hover {
        border-color: lighten($col-ic-blue, 20%);
      }
      > svg {
        display: inline-block;
        vertical-align: middle;
        path {
          fill: #ffffff;
        }
      }
    }
  }

  .asd__keyboard-shortcuts-trigger {
    border-right-color: $col-ic-blue-hover;
  }

  .asd__keyboard-shortcuts-menu {
    color: #333;
  }

  .datepicker-trigger {
    position:relative;
  }
  .asd__month.hidden {
    display: inline-block!important;
  }

  #high-contrast {
    .asd {
      &__wrapper {
        background: $col-ic-highcontrast-input-bg;
        color: $col-ic-highcontrast-text;
      }
      &__day {
        &--enabled {
          color: $col-ic-highcontrast-text !important;
          &:focus {
            outline-color: $col-ic-highcontrast-text !important;
          }
        }
        &--today {
          border-color: $col-ic-highcontrast-text !important;
        }
      }
    }
  }
</style>